





















































import { Component, Vue } from 'vue-property-decorator';
import {GeneralService} from '../services/general-service';
import ProgramLevel from '../components/ProgramLevel.vue';
import config from '../services/api-config';
import router from '../router';
import AuthService from '../services/auth-service';

@Component({
  components: {
      'program-level': ProgramLevel
  },
})

export default class Timetable extends Vue {
    private service = new GeneralService();
    private timeTableJSON: any = [];
    private timeTable: any = [];
    private isRoom = "";
    private isTeacher = "";
    private auth = new AuthService();

    dayOfWeekAsString(dayIndex) {
    return [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ][dayIndex];
  }
    

    resetTimeTable() {
    let today = this.dayOfWeekAsString(new Date().getDay());
    this.timeTableJSON = [];
    let days: any = [];
    let daysData: any = [];
    if (this.timeTable[0].Status !== "902") {
      for (let day of this.timeTable) {
        let finalData: any = [];
        days.push(day.Day);
        for (let dataTable of day.TimeTableData) {
          let str = dataTable.ClassTime + "\n" + dataTable.SubjectName;
          if (this.isRoom === "checked") {
            str += "\n" + dataTable.Room;
          }

          if (this.isTeacher === "checked") {
            str += "\n" + dataTable.TeacherName;
          }

          finalData.push(str);
        }

        daysData.push(finalData);
      }

      for (let i = 0; i < daysData[0].length; i++) {
        let obj = {};
        for (let j = 0; j < days.length; j++) {
          obj[days[j]] = daysData[j][i];
          if (days[j] == today) {
            obj["_cellVariants"] = {};
            obj["_cellVariants"][days[j]] = "info";
          }
        }
        this.timeTableJSON.push(obj);
      }
    }
  }

    mounted() {
        this.$watch("isRoom", e => {
        this.resetTimeTable();
        });
        this.$watch("isTeacher", e => {
        this.resetTimeTable();
        });

        let username = this.auth.session.userName.split('@')[0];
        this.service.getTimeTable(username).then(result => {
            let today = this.dayOfWeekAsString(new Date().getDay());
            this.timeTable = result.data.Data;
            let days: any = [];
            let daysData: any = [];
            if (this.timeTable[0].Status !== "902") {
              for (let day of this.timeTable) {
                let finalData: any = [];
                days.push(day.Day);
                for (let dataTable of day.TimeTableData) {
                  let str = dataTable.ClassTime + "\n" + dataTable.SubjectName;
                  if (this.isRoom) {
                    str += "\n" + dataTable.Room;
                  }

                  if (this.isTeacher) {
                    str += "\n" + dataTable.TeacherName;
                  }

                  finalData.push(str);
                }

                daysData.push(finalData);
              }

              for (let i = 0; i < daysData[0].length; i++) {
                let obj = {};
                for (let j = 0; j < days.length; j++) {
                  obj[days[j]] = daysData[j][i];
                  if (days[j] == today) {
                    obj["_cellVariants"] = {};
                    obj["_cellVariants"][days[j]] = "info";
                  }
                }
                this.timeTableJSON.push(obj);
              }
            }
          });

    }
   
}
